import React from 'react';
import moment from 'moment';

const styles = {
  textStyle: {
    textAlign: 'center',
    fontSize: '4rem',
    margin: '1.6rem'
  }
};

export default class Clock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      time: moment().format('LTS')
    };
  }
  componentDidMount() {
    this.intervalID = setInterval(() => this.tick(), 1000);
  }
  componentWillUnmount() {
    clearInterval(this.intervalID);
  }
  tick() {
    this.setState({
      time: moment().format('LTS')
    });
  }
  render() {
    return <h1 style={styles.textStyle}>{this.state.time}</h1>;
  }
}
